/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./DateOutput.vue?vue&type=template&id=3afc30ca"
import script from "./DateOutput.vue?vue&type=script&setup=true&lang=ts"
export * from "./DateOutput.vue?vue&type=script&setup=true&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports